import L from 'lodash'
import { getCookie } from '@straal/core/utils/cookieHelpers.ts'

export const ajaxRequest = function(url, requestType, payload = null) {
  return new Promise(function(resolve, reject) {
    const token = getCookie('csrf_token')
    const headers = [
      {
        name: 'X-Requested-With',
        value: 'XMLHttpRequest',
      },
      {
        name: 'Content-Type',
        value: 'application/json',
      },
      {
        name: 'X-CSRF-Token',
        value: token,
      },
    ]

    const xhr = new XMLHttpRequest()

    xhr.open(requestType, url, true)
    headers.map(function(header) {
      xhr.setRequestHeader(header.name, header.value)
    })
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        let response = {
          success: xhr.status === 200,
        }

        if (xhr.responseText) {
          try {
            response = L.merge(response, JSON.parse(xhr.responseText))
          } catch (err) {
            response = L.merge(response, { responseText: xhr.responseText })
          }
        }

        if (response.success) resolve(response)
        else reject(response)
      }
    }
    xhr.send(!L.isNull(payload) ? JSON.stringify(payload) : payload)
  })
}
